import React from 'react';
import { Grid, Button, Box, Typography } from '@mui/material';
import styles from './Testing.module.css'
import { Image } from 'cloudinary-react';


function Testing() {

  return (
<div>
<Box sx={{bgcolor:'#ffff',boxShadow: '0px 0px 2px 0px',p:'1%'
 }}>
     <form >

        <Typography sx={{mb:'2%'}}>My Profile</Typography>
        <Typography  sx={{borderTop:'2px solid black'}}></Typography>
        <Typography  className={styles.hen}>General Information</Typography>
      <Grid container spacing={3} className={styles.formContainer} >
        <Grid item xs={12} sm={6} lg={4}>
          <label htmlFor="firstName">Full Name:</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            required
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <label htmlFor="lastName">User Name:</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            required
          />
        </Grid>
        <Grid item xs={12} lg={4} className={styles.imageContainer}>
        <Image publicId="https://res.cloudinary.com/dxluokypg/image/upload/v1682423845/steel_1_lgk5mz.svg" cloudName="dxluokypg" />
      
        </Grid>
        <Grid item xs={12} lg={4}>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            required
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <label htmlFor="Mobile Number">Mobile Number:</label>
          <input
            type="Mobile Number"
            id="Mobile Number"
            name="Mobile Number"
            required
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          {/* Empty space */}
        </Grid>
        <Grid item xs={12} lg={4}>
          <label htmlFor="number">Registered on:</label>
          <input
            type="number"
            id="number"
            name="number"
            required
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <label htmlFor="confirmPassword">Role:</label>
          <input
            type="text"
            id="text"
            name="text"
            required
          />
        </Grid>
        <Grid item xs={4} lg={3} sx={{mt:'2%'}}>
          <Button
            type="submit"
            variant="outlined"
            color="primary"
            
          >
        Change password
          </Button>
        </Grid>
        <Grid item xs={4}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            
          >
           Update & Save
          </Button>
        </Grid>
      </Grid>
    </form>

 </Box>

 <Box sx={{bgcolor:'#ffff',boxShadow: '0px 0px 2px 0px',p:'2%',mt:'5%'
 }}>
     <form >
      <Grid container spacing={3} className="form-container" >
        <Grid item xs={12} sm={6} lg={4}>
          <label htmlFor="firstName">First Name:</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            required
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <label htmlFor="lastName">Last Name:</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            required
          />
        </Grid>
        <Grid item xs={12} lg={4} className="image-container">
        <Image publicId="https://res.cloudinary.com/dxluokypg/image/upload/v1682423845/steel_1_lgk5mz.svg" cloudName="dxluokypg" />
      
        </Grid>
        <Grid item xs={12} lg={4}>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            required
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <label htmlFor="Mobile Number">Mobile Number:</label>
          <input
            type="Mobile Number"
            id="Mobile Number"
            name="Mobile Number"
            required
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          {/* Empty space */}
        </Grid>
        <Grid item xs={12} lg={4}>
          <label htmlFor="number">Registered on:</label>
          <input

            type="number"
            id="number"
            name="number"
            required
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <label htmlFor="confirmPassword">Role:</label>
          <input
            type="text"
            id="text"
            name="text"
            required
          />
        </Grid>
        <Grid item xs={3} sx={{mt:'3%'}}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            
          >
          Change
          </Button>
        </Grid>
        <Grid item xs={4}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            
          >
           Update & Save
          </Button>
        </Grid>
      </Grid>
    </form>

 </Box>
</div>
  );
}

export default Testing;
 


